import { PluginWorkSite } from 'rwl-shared/dist/models';
import { IconSymbol, Icons } from 'rwl-ui';

export function determineIconForWorkSite(
    workSite: PluginWorkSite,
    accountLabel?: string
): IconSymbol | undefined {
    const hasReview = !!workSite.content.find((c) => c.type === 'Review');
    if (!workSite.showcase && !hasReview) {
        return;
    }

    const workSiteIcon = lookupIconForLabels(
        workSite.labels?.map((l) => l.externalId) || []
    );
    if (workSiteIcon) {
        return workSiteIcon;
    }

    if (accountLabel) {
        const accountLabelIcon = lookupIconForLabels([accountLabel]);
        if (accountLabelIcon) {
            return accountLabelIcon;
        }
    }

    return Icons.HOUSE_ICON;
}

function lookupIconForLabels(labels: string[]): IconSymbol | undefined {
    const iconKey = Object.keys(labelToIconMap).find((key) => {
        return labels.includes(key);
    });

    return iconKey ? labelToIconMap[iconKey] : undefined;
}

// FIFO, first match wins.  If you have a special icon for a JobService put it before the icon for the parent Service
const labelToIconMap: Record<string, IconSymbol> = {
    'JobService:Windows:Blinds': Icons.BLINDS_ICON,
    'Service:Windows': Icons.WINDOW_ICON,
    'JobService:PestControl:Mosquito': Icons.MOSQUITO_ICON,
    'Service:PestControl': Icons.NO_BUG_ICON,
    'Service:Garage': Icons.CAR_ICON,
    'JobService:Chimney:Fireplace': Icons.FIREPLACE_ICON,
    'Service:Chimney': Icons.CHIMNEY_ICON,
    'JobService:HVAC:UVLights': Icons.FAN_ICON,
    'JobService:HVAC:Furnace': Icons.HOT_TEMP_ICON,
    'JobService:HVAC:HeatPump': Icons.HOT_TEMP_ICON,
    'JobService:HVAC:DuctsAndVents': Icons.FAN_ICON,
    'JobService:HVAC:RadiantHeating': Icons.HOT_TEMP_ICON,
    'JobService:HVAC:Boiler': Icons.HOT_TEMP_ICON,
    'Service:HVAC': Icons.COLD_TEMP_ICON,
    'JobService:FireAndWaterRestoration:Smoke': Icons.HOUSE_FIRE_ICON,
    'JobService:FireAndWaterRestoration:Flood': Icons.HOUSE_WATER_ICON,
    'Service:Painting': Icons.PAINT_ICON,
    'Service:Plumbing': Icons.PIPE_ICON,
    'Service:Siding': Icons.SIDING_ICON,
    'Service:EnergyEfficiency': Icons.SOLAR_ICON,
    'Service:Solar': Icons.SOLAR_ICON,
    'Service:TreeServices': Icons.TREE_ICON,
};
